// removed by extract-text-webpack-plugin
module.exports = {"badgesList":"lnIOb"};